import { Observable, timer, throwError } from "rxjs";
import { mergeMap, retryWhen } from "rxjs/operators";

export function retryWithDelay<T>(
  retries: number,
  delayMs: number,
  callback: (error: any, attempt: number, retries: number) => void
): (src: Observable<T>) => Observable<T> {
  return (src: Observable<T>) =>
    src.pipe(
      retryWhen((errors) =>
        errors.pipe(
          mergeMap((error, i: number) => {
            if (i < retries) {
              callback(error, i, retries);
              return timer(delayMs);
            }
            // RxJS 6: throwError(x) forwards x. Do not pass a factory unless on RxJS 7+.
            return throwError(error);
          })
        )
      )
    );
}
